<template>
  <div class="card-content" id="preview-page" :style="{
      width:
        answerSheet.acCardPanes == 1
          ? '794px'
          : answerSheet.acCardPanes == 2
          ? '1588px'
          : '1781px',
      height: pageHeight,
    }">
    <template v-if="pageCell.length > 0">
      <PreviewWrapperRow :myStyle="{
          width:
            answerSheet.acCardPanes == 1
              ? 794
              : answerSheet.acCardPanes == 2
              ? 1588
              : 1781,
          height: pageLayoutTop,
        }" :acCardPanes="answerSheet.acCardPanes" :topicTotalNum="topicTotalNum" />
      <div v-if="columns > 1">
        <div v-for="(group, groupIndex) in groupedPages" :key="'wrap-'+groupIndex" class="page-wrap" :style="{
              width:
                answerSheet.acCardPanes == 2
                  ? 1588 + 'px'
                  : 1781 + 'px',
              height: pageLayoutTop + 'px',
            }">

          <div class="position_remind_text" v-show="groupIndex != 0" :style="`${
              answerSheet.acCardPanes === 1 ? 'padding-top: 21px;' : 'padding-top: 18px;'
            }`">
            <span class="position_remind_value">请在各题目的答题区域内作答，超出黑色矩形边框限定区域的答案无效</span>
          </div>
          <div v-for="(page, pageIndexInGroup) in group" :key="'page-'+groupIndex+'-'+pageIndexInGroup"
            class="page-cell" :style="{
              width: `${page.layout.width}px`,
              height: `${page.layout.height}px`,
              position: page.layout.position,
              left: page.layout.left,
              top: `${page.layout.top}px`,
              'margin-left': `${page.layout.marginLeft}px`,
              padding: page.layout.padding,
            }">
            <!-- 用来画线 -->
            <div class="my_border" :style="{
                'border-radius': '12px',
                width: `${page.layout.width + 20}px`,
                height: `${page.layout.height + 16}px`,
                position: page.layout.position,
                left: `${page.layout.borderLeft}`,
                top: '70px',
              }"></div>
            <div v-if="groupIndex * columns + pageIndexInGroup == 0" class="ab-box">
              <div v-if="answerSheet.acCardABSet" class="a-b basics-card-tips"
                :style="{ marginTop: `${cardNamePadding - 17}px` }">
                <div style="padding-top: 15px">
                  <p class="mt">
                    <span class="c-t c-b c-b0"></span>
                    <span class="c-t no-margin">A卷</span>
                  </p>
                  <span class="c-t c-b c-b1"></span>
                  <span class="c-t no-margin">B卷</span>
                  <br />
                  <br />
                </div>
              </div>
              <div class="card-name" :style="{
                  padding: `${cardNamePadding}px 0px`,
                  width: answerSheet.acCardABSet ? '86%' : '100%',
                }">
                <div v-if="!acCardHideOrcode">
                  <div v-show="!acCardHideOrcode" ref="qrcodeContainer" id="qrcode" class="qrcodeBox"></div>
                </div>
                <!-- <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入内容"
                    v-model="answerSheet.acCardName"
                    maxlength="50"
                    show-word-limit
                ></el-input>-->
                <!-- <span
                  v-for="(name, index) in answerSheet.acCardName &&
                  answerSheet.acCardName.split('\n')"
                  :key="index"
                  v-html="answerSheet.acCardNameHtml"
                  ></span
                > -->
                <span v-html="answerSheet.acCardNameHtml" class="card-title"></span>
              </div>
            </div>
            <!-- 关键：计算全局 pageIndex -->
            <Basics v-if="isShowBasics(groupIndex * columns + pageIndexInGroup)"
              :msg="{ pageIndex: groupIndex * columns + pageIndexInGroup }" />
            <div class="wrapper-content" :style="{ height: page.contentHeight + 'px' }">
              <!-- <div id="div1" @click="xx">adfadsf</div> -->
              <template v-for="(obj, index) in page.fillTopiclist">
                <fill-topic :isPreview="isPreview" v-if="obj.type === 1" :msg="obj" :key="'cont' + index" />
                <objective-topic :isPreview="isPreview" v-if="obj.type === 2" :msg="obj" :key="'obj' + index" />
                <answer-topic :isPreview="isPreview" v-if="obj.type === 3"
                  :msg="{ ...obj, pageIndex: groupIndex, currentIndexInPage: index }" :key="'obj' + index" />
                <writing-en-topic :isPreview="isPreview" v-if="obj.type === 4" :msg="obj" :key="'obj' + index" />
                <writing-topic :isPreview="isPreview" v-if="obj.type === 5" :msg="obj" :key="'obj' + index" />
                <choose-topic :isPreview="isPreview" v-if="obj.type == 6" :msg="obj" :key="'obj' + index" />
                <non-answer-topic :isPreview="isPreview" v-if="obj.type == 7" :msg="obj" :key="'obj' + index" />  
              </template>
              <div id="test-obj-group" class="obj-group"></div>
            </div>
            <div v-if="isShowPageNum(groupIndex * columns + pageIndexInGroup)" class="page-num" :style="{
                left: `${
                  answerSheet.acCardPanes === 1
                    ? 0
                    : answerSheet.acCardPanes === 2
                    ? 395
                    : 600
                }px`,
              }">
              {{ getPageNumber(groupIndex * columns + pageIndexInGroup) }}
            </div>
            <div v-if="isShowPoint(groupIndex * columns + pageIndexInGroup, 'left')" class="position_point left"></div>
            <div v-if="isShowPoint(groupIndex * columns + pageIndexInGroup, 'right')" class="position_point right">
            </div>
            <div v-if="isShowPoint(groupIndex * columns + pageIndexInGroup, 'top')" class="position_point top"></div>
            <div v-if="isShowPoint(groupIndex * columns + pageIndexInGroup, 'bottom')" class="position_point bottom">
            </div>
            <svg id="barcode"
              v-if="answerSheet.acCardPanes == 2 && groupIndex * columns + pageIndexInGroup % 2 == 0"></svg>
          </div>

          <div v-if="addBlackPage && groupIndex== groupedPages.length-1" class="page-cell" :style="{
              width: `${pageCellCopy[pageCellCopy.length - 1].layout.width}px`,
              height: `${pageCellCopy[pageCellCopy.length - 1].layout.height}px`,
              position: pageCellCopy[pageCellCopy.length - 1].layout.position,
              left: answerSheet.acCardPanes === 3 ? '0' : '50%',
              top: `${pageCellCopy[pageCellCopy.length - 1].layout.top}px`,
              'margin-left': `${pMarginLeft[1]}px`,
              padding: pMarginLeft[3],
            }">
            <div class="wrapper-content" :style="{
                height: pageCellCopy[pageCellCopy.length - 1].layout.height + 'px',
              }"></div>
            <div class="position_point right"></div>
            <div class="position_point top"></div>
          </div>
        </div>
      </div>
      <div v-else>
        <div v-for="(page, pageIndex) in pageCellCopy" :key="'page' + pageIndex" class="page-cell" :style="{
            width: `${page.layout.width}px`,
            height: `${page.layout.height}px`,
            position: page.layout.position,
            left: page.layout.left,
            top: `${page.layout.top}px`,
            'margin-left': `${page.layout.marginLeft}px`,
            padding: page.layout.padding,
          }">
          <div class="position_remind_text position_remind_text_page" v-show="pageIndex != 0" :style="`${
              answerSheet.acCardPanes === 1 ? 'padding-top: 21px;' : 'padding-top: 18px;'
            }`">
            <span class="position_remind_value">请在各题目的答题区域内作答，超出黑色矩形边框限定区域的答案无效</span>
          </div>
          <!-- 用来画线 -->
          <div class="my_border" :style="{
              'border-radius': '12px',
              width: `${page.layout.width + 20}px`,
              height: `${page.layout.height + 16}px`,
              position: page.layout.position,
              left: `${page.layout.borderLeft}`,
              top: '70px',
            }"></div>
          <div v-if="pageIndex == 0" class="ab-box">
            <div v-if="answerSheet.acCardABSet" class="a-b basics-card-tips"
              :style="{ marginTop: `${cardNamePadding - 17}px` }">
              <div style="padding-top: 15px">
                <p class="mt">
                  <span class="c-t c-b c-b0"></span>
                  <span class="c-t no-margin">A卷</span>
                </p>
                <span class="c-t c-b c-b1"></span>
                <span class="c-t no-margin">B卷</span>
                <br />
                <br />
              </div>
            </div>
            <div class="card-name" :style="{
                padding: `${cardNamePadding}px 0px`,
                width: answerSheet.acCardABSet ? '86%' : '100%',
              }">
              <div v-if="!acCardHideOrcode">
                <div class="qrcodeBox" v-if="qrCodeDataUrl"><img :src="qrCodeDataUrl"></div>
                <div v-else ref="qrcodeContainer" id="qrcode" class="qrcodeBox"></div>
              </div>
              <!-- <el-input
                  type="textarea"
                  :rows="2"
                  placeholder="请输入内容"
                  v-model="answerSheet.acCardName"
                  maxlength="50"
                  show-word-limit
              ></el-input>-->
              <!-- <span
                v-for="(name, index) in answerSheet.acCardName &&
                answerSheet.acCardName.split('\n')"
                :key="index"
                v-html="answerSheet.acCardNameHtml"
                ></span
              > -->
              <span v-html="answerSheet.acCardNameHtml" style="width: auto;height: auto;" class="card-title"></span>
            </div>
          </div>
          <Basics v-if="isShowBasics(pageIndex)" :msg="{pageIndex: pageIndex}" />
          <div class="wrapper-content" :style="{ height: page.contentHeight + 'px' }">
            <!-- <div id="div1" @click="xx">adfadsf</div> -->
            <template v-for="(obj, index) in page.fillTopiclist">
              <fill-topic :isPreview="isPreview" v-if="obj.type === 1" :msg="obj" :key="'cont' + index" />
              <objective-topic :isPreview="isPreview" v-if="obj.type === 2" :msg="obj" :key="'obj' + index" />
              <answer-topic :isPreview="isPreview" v-if="obj.type === 3"
                :msg="{ ...obj, pageIndex: pageIndex, currentIndexInPage: index }" :key="'obj' + index" />
              <writing-en-topic :isPreview="isPreview" v-if="obj.type === 4" :msg="obj" :key="'obj' + index" />
              <writing-topic :isPreview="isPreview" v-if="obj.type === 5" :msg="obj" :key="'obj' + index" />
              <choose-topic :isPreview="isPreview" v-if="obj.type == 6" :msg="obj" :key="'obj' + index" />
              <non-answer-topic :isPreview="isPreview" v-if="obj.type == 7" :msg="obj" :key="'obj' + index" />  
            </template>
            <div id="test-obj-group" class="obj-group"></div>
          </div>
          <div v-if="isShowPageNum(pageIndex)" class="page-num" :style="{
              left: `${
                answerSheet.acCardPanes === 1
                  ? 0
                  : answerSheet.acCardPanes === 2
                  ? 395
                  : 600
              }px`,
            }">
            {{ getPageNumber(pageIndex) }}
          </div>
          <div v-if="isShowPoint(pageIndex, 'left')" class="position_point left"></div>
          <div v-if="isShowPoint(pageIndex, 'right')" class="position_point right"></div>
          <div v-if="isShowPoint(pageIndex, 'top')" class="position_point top"></div>
          <div v-if="isShowPoint(pageIndex, 'bottom')" class="position_point bottom"></div>
          <svg id="barcode" v-if="answerSheet.acCardPanes == 2 && pageIndex % 2 == 0"></svg>
        </div>

      </div>
      <div v-if="
          answerSheet.acCardPanes === 3 &&
          pageCellCopy && pageCellCopy.length % answerSheet.acCardPanes === 1
        " class="page-cell" :style="{
          width: `${pageCellCopy[pageCellCopy.length - 1].layout.width}px`,
          height: `${pageCellCopy[pageCellCopy.length - 1].layout.height}px`,
          position: pageCellCopy[pageCellCopy.length - 1].layout.position,
          left: pageCellCopy[pageCellCopy.length - 1].layout.left,
          top: `${pageCellCopy[pageCellCopy.length - 1].layout.top}px`,
          'margin-left': `${pMarginLeft[0]}px`,
          padding: pMarginLeft[2],
        }">
        <div class="wrapper-content" :style="{
            height: pageCellCopy[pageCellCopy.length - 1].layout.height + 'px',
          }"></div>
      </div>

    </template>
  </div>
</template>

<script>
  import * as QRCode from 'qrcodejs2';
  import { mapGetters, mapState } from "vuex";
  import PreviewWrapperRow from "@/components/common/preview-wrapper-row/preview-wrapper-row";
  import Basics from "@/components/TopicMakeBox/BasicsCardBox";
  import FillTopic from "@/components/TopicShow/FillTopic";
  import ObjectiveTopic from "@/components/TopicShow/ObjectiveTopic";

  // import AnswerTopic from "@/components/TopicShow/AnswerTopic";
  import ChooseTopic from "@/components/TopicShow/ChooseTopic";
  import AnswerTopic from "@/components/TopicShow/AnswerTopic";
  import WritingEnTopic from "@/components/TopicShow/WritingEnTopic";
  import WritingTopic from "@/components/TopicShow/WritingTopic";
  import NonAnswerTopic from "@/components/TopicShow/NonAnswerTopic";

  import { PAGE_LAYOUT_TOP } from "@/subjects/constant";
  const PREVIEW_WRAP_ROW_HEIGHT = 1133;
  export default {
    name: "PreviewWrapper",
    components: {
      Basics,
      ObjectiveTopic, // 客观题组件
      FillTopic, // 填空题组件
      AnswerTopic, // 解答题组件
      ChooseTopic,
      WritingEnTopic,
      WritingTopic,
      NonAnswerTopic,
      PreviewWrapperRow, // 用来预览装载提醒考生作答信息的div
    },
    props: {
      isPreview: {
        type: Boolean,
        default: false,
      },
      preAcCardGuid: {
        default: ''
      },
      acCardHideOrcode: {
        type: Boolean,
        default: true,
      }
    },
    computed: {
      ...mapGetters({
        answerSheet: "answerPanel/answerSheet",
        acCardSetType: "answerPanel/acCardSetType",
      }),
      ...mapState("card", {
        pageCell: (state) => state.pageCell, //纸张的数据
        pageCellCopyData: (state) => state.pageCellCopy, //纸张的数据
        pageCellString: (state) => state.pageCellString,
      }),
      topicTotalNum() {
        console.log("this.pageCell.length", this.pageCell.length)
        return this.pageCell.length;
      },
      cardNamePadding() {
        let padding = 20;  //二三栏时，只能是 20原 29 会造成计算错误
        // 答卷设置（会影响预览展示考生信息页的高度）  0、正常 1、条码 2、手写考号 3、二栏且考号位数大于9 或 三栏且考号位数大于8
        switch (this.acCardSetType) {
          case 1:
            padding = 20;
            break;
          case 2:
            padding = 20;
            break;
          case 3:
            padding = 20;
            break;
          case 4:
            padding = 48;
            break;
          case 5:
            padding = 10;
            break;
          default:
            padding = 10;
        }
        return padding;
      },
      pMarginLeft() {
        let obj = [0, 0, "62px 44px", "80px 62px 62px 26px"];
        const { acCardPanes } = this.answerSheet;
        if (acCardPanes === 3) {
          obj[0] = 611;
          obj[1] = 611 * 2 - 62;
          obj[2] = "72px 22px";
          obj[3] = "80px 64px 62px 42px";
          // obj[3] = "80px 62px 22px";
        }
        return obj;
      },
      addBlackPage() {
        let acCardPanes = this.answerSheet.acCardPanes;
        return (
          (acCardPanes === 2 && this.pageCellCopy && this.pageCellCopy.length % acCardPanes === 1) ||
          (acCardPanes === 3 && this.pageCellCopy && this.pageCellCopy.length % acCardPanes !== 0)
        );
      },
      pageHeight() {
        let acCardPanes = this.answerSheet.acCardPanes;
        return (acCardPanes == 1
          ? this.pageCell.length
          : acCardPanes == 2
            ? Math.ceil(this.pageCell.length / 2)
            : Math.ceil(this.pageCell.length / 3)) *
          this.pageLayoutTop +
          'px'
      },
      // 计算分栏数
      columns() {
        const pane = this.answerSheet.acCardPanes;
        return pane === 2 || pane === 3 ? pane : 1;
      },
      // 将页面数据按分栏数分组
      groupedPages() {
        const groups = [];
        console.log("this.pageCellCopy", this.pageCellCopy)
        for (let i = 0; i < this.pageCellCopy.length; i += this.columns) {
          groups.push(this.pageCellCopy.slice(i, i + this.columns));
        }
        console.log("groups", groups)
        return groups;

      }
    },
    watch: {
      pageCellCopyData: {
        handler(newVal, oldVal) {
          this.pageCellCopy = newVal ? [...newVal] : [];

        },
        deep: true,
        immediate: true,
      },
    },
    //   pageCellCopy() {
    //     return this.pageCellCopyData
    // },

    data() {
      return {
        acCardGuid: this.$route.query.guid,
        qrCodeDataUrl: null,
        pageLayoutTop: PAGE_LAYOUT_TOP,
        pageCellCopy: []
      };
    },
    created() { },
    mounted() {
      //console.log('window.UE.Editor:::',window.UE.Editor);
      console.log(' pre acCardHideOrcode::::::::', this.acCardHideOrcode);
      this.initQRCode();
      const { acCardYJType } = this.answerSheet;
      // this.pageCellCopyData.forEach(item => {
      //   item.fillTopiclist.forEach(fillObj => {
      //     // console.log('fillObj===log',fillObj.initDragHeight);
      //     fillObj.initDragHeight = acCardYJType == 2 ? fillObj.resetPage(state) : fillObj.initDragHeight
      //     // console.log('fillObj===log==1',fillObj.initDragHeight);
      //   })
      // });
      // this.pageCellCopy = [...this.pageCellCopyData]
    },
    methods: {
      initQRCode() {

        try {
          // this.$refs 被改不能正常引用 使用原生getElementById
          const containerEl = this.$refs.qrcodeContainer.$el ||
            document.getElementById('qrcode');

          new QRCode(containerEl, {
            text: this.preAcCardGuid ? this.preAcCardGuid : this.acCardGuid,
            width: 68,
            height: 68,
            colorDark: '#000000',
            colorLight: '#ffffff',
          });
          // 监听容器内的 img 标签加载完成
          const imgEl = containerEl.querySelector('img');
          if (imgEl) {
            imgEl.onload = () => {
              // 提取 Base64 地址
              this.qrCodeDataUrl = imgEl.src;
            };
          }
        } catch (error) {

        }


      },
      isShowBasics(index) {
        return this.$parent.showBasics(index);
      },
      getPageNumber(pageIndex) {
        const { acCardPanes } = this.answerSheet;
        const index = pageIndex + 1;
        let num = 0;
        if (acCardPanes === 1) {
          num = index;
        } else if (acCardPanes === 2 && index % 2 === 1) {
          num = Math.ceil(index / 2);
        } else if (acCardPanes === 3 && index % 3 === 1) {
          num = Math.ceil(index / 3);
        }
        return (
          "第" +
          num +
          "页 共" +
          (this.pageCellCopy.length
            ? Math.ceil(this.pageCellCopy.length / acCardPanes)
            : 0) +
          "页"
        );
      },
      // 是否展示页码
      isShowPageNum(pageIndex) {
        const { acCardPanes } = this.answerSheet;
        const index = pageIndex + 1;
        return (
          acCardPanes === 1 ||
          (acCardPanes === 2 && index % 2 === 1) ||
          (acCardPanes === 3 && index % 3 === 1)
        );
      },
      // 是否展示黑色块边
      isShowPoint(pageIndex, type) {
        let flag = false;
        const index = pageIndex + 1;
        const { acCardPanes } = this.answerSheet;
        if (acCardPanes === 1) {
          flag = true;
        } else {
          if (
            ["left", "bottom"].indexOf(type) > -1 &&
            this.isShowPageNum(pageIndex)
          ) {
            // 左右的黑块
            flag = true;
          } else if (
            ["right", "top"].indexOf(type) > -1 &&
            ((acCardPanes === 2 && index % 2 === 0) ||
              (acCardPanes === 3 && index % 3 === 0))
          ) {
            flag = true;
          }
        }
        return flag;
      },
      /**
       * 根据页码显示提醒考生信息文字
       * 这个展示根据一栏二栏三栏决定 一栏就是除了第一页不展示 其他都会在头部显示
       * 二栏 三栏 在每个row的中间展示考试题型文案
       */
      isShowRemindText(pageIndex) {
        pageIndex = pageIndex + 1;
        let acCardPanes = this.answerSheet.acCardPanes; // 栏数
        if (acCardPanes === 1 && pageIndex != 0) {
          // 一栏
          this.remindTextStyle = "";
          return true;
        } else if (acCardPanes === 2 && pageIndex % 2 == 1) {
          // 二栏
          this.remindTextStyle = "";
          return true;
        } else if (acCardPanes === 3 && pageIndex % 3 == 2) {
          // 三栏
          this.remindTextStyle = "";
          return true;
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  #preview-page {
    /* background: #fff; */
  }

  .page-num {
    z-index: 999999;
    width: 100%;
    text-align: center;
    position: absolute;
    left: 0;
    bottom: 25px;
    font-size: 12px;
    font-weight: 700;
    /* font-family: Times, "Times New Roman", SimSun-ExtB, SimSun, NSimSun, serif; */

  }

  .red-card {
    border: 1px solid var(--card-color);
    border-radius: 5px;

    .basic-card {
      border: 1px solid var(--card-color);
      border-radius: 5px;
      padding: 5px;

      .i-cont {
        border-bottom: 1px solid var(--card-color);
      }
    }

    .ab-box {
      border: 1px solid var(--card-color);
      border-radius: 4px;
      border-bottom: none;
      border-radius: inherit;
    }

    .group {
      .gro-item {
        color: var(--card-color);

        &:first-child {
          color: #000;
        }
      }
    }

  }

  .my_border {
    border: 1px solid var(--card-color);
  }

  .card-name {
    text-align: center;
    display: inline-block !important;
  }

  .qrcodeBox {
    position: absolute;
    width: 68px;
    height: 68px;
    left: 0;
    top: 0;
    overflow: hidden;
  }

  .position_remind_text {
    width: 100%;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    position: relative;
    z-index: 2010;
  }

  .position_remind_text_page {
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
  }
  .card-name {
    p {
      display: inline-block !important;
    }
    span {
      display: inline-block !important;
    }
  }
  .card-title {
    display: inline-block !important;
    padding: 5px 6px;
  }

  .card-title p {
    display: inline-block !important;
  }
</style>